import ProcessedBookingGroup from "./processedBookingGroup";

export default class ProcessedBookingGroups {
  // List of processed booking models.
  events: ProcessedBookingGroup[];
  // Total recieved payment from multiple events for a given month.
  totalPrice: number;
  // Total number of transactions from multiple events for a given month.
  totalCount: number;
  // Indicate every processed booking is successful.
  isSuccess: boolean;

  constructor(
    events: ProcessedBookingGroup[],
    totalPrice: number,
    totalCount: number,
    isSuccess: boolean
  ) {
    this.events = events;
    this.totalPrice = totalPrice;
    this.totalCount = totalCount;
    this.isSuccess = isSuccess;
  }
}
